import { initContract } from '@ts-rest/core';
import { z } from 'zod';
import {
  createConversationSchema,
  conversationSchema,
  conversationWithMessagesSchema,
  sendMessageSchema,
  messageSchema,
  updateConversationSchema,
  conversationListResponseSchema,
  conversationFiltersSchema,
} from '../schemas/conversations.schemas';
import { errorResponseSchema, paginationQuerySchema } from '../schemas/common.schemas';

const c = initContract();

export const conversationsContract = c.router({
  createConversation: {
    method: 'POST',
    path: '/conversations',
    body: createConversationSchema,
    responses: {
      201: conversationSchema,
      400: errorResponseSchema,
      401: errorResponseSchema,
    },
    summary: 'Create a new conversation',
  },
  getConversation: {
    method: 'GET',
    path: '/conversations/:id',
    pathParams: z.object({
      id: z.string().uuid(),
    }),
    responses: {
      200: conversationWithMessagesSchema,
      404: errorResponseSchema,
      401: errorResponseSchema,
    },
    summary: 'Get conversation by ID with messages',
  },
  listConversations: {
    method: 'GET',
    path: '/conversations',
    query: paginationQuerySchema.merge(conversationFiltersSchema),
    responses: {
      200: conversationListResponseSchema,
      400: errorResponseSchema,
      401: errorResponseSchema,
    },
    summary: 'List conversations with pagination and filters',
  },
  updateConversation: {
    method: 'PATCH',
    path: '/conversations/:id',
    pathParams: z.object({
      id: z.string().uuid(),
    }),
    body: updateConversationSchema,
    responses: {
      200: conversationSchema,
      404: errorResponseSchema,
      400: errorResponseSchema,
      401: errorResponseSchema,
    },
    summary: 'Update conversation',
  },
  sendMessage: {
    method: 'POST',
    path: '/conversations/:id/messages',
    pathParams: z.object({
      id: z.string().uuid(),
    }),
    body: sendMessageSchema,
    responses: {
      201: messageSchema,
      404: errorResponseSchema,
      400: errorResponseSchema,
      401: errorResponseSchema,
    },
    summary: 'Send a message in a conversation',
  },
  getMessages: {
    method: 'GET',
    path: '/conversations/:id/messages',
    pathParams: z.object({
      id: z.string().uuid(),
    }),
    query: paginationQuerySchema,
    responses: {
      200: z.object({
        messages: z.array(messageSchema),
        pagination: z.object({
          page: z.number(),
          limit: z.number(),
          total: z.number(),
          totalPages: z.number(),
        }),
      }),
      404: errorResponseSchema,
      401: errorResponseSchema,
    },
    summary: 'Get messages for a conversation',
  },
});
